import React from 'react';
import ReactToggle from 'react-toggle';
import TaxonomySelection from '../../helper/taxonomySelection';
import MetadataSelection from '../../helper/metadataSelection';
import Select from 'react-select';
import { findIndex } from 'underscore';
import clone from 'clone';
import BuildActions from '../../builder/action/builderActions';
import panelActions from '../action/panelActions';
import { stringify } from '../../helper/helperFunction';

class LinearCheckBoxPanel extends React.Component {
    constructor(props) {
      super(props);
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      this.handleTaxonomy = this.handleTaxonomy.bind(this);
      this.handleMetakey = this.handleMetakey.bind(this);
      this.handleChangeDataTypes = this.handleChangeDataTypes.bind(this);
      this.handleChangeToogleViewTypes = this.handleChangeToogleViewTypes.bind(this);
      this.handleValueIncrement = this.handleValueIncrement.bind(this);
      this.handleValueDecrement = this.handleValueDecrement.bind(this);
      this.handleShowItem = this.handleShowItem.bind(this);
      this.handleChangeLoadMore = this.handleChangeLoadMore.bind(this);
      this.saveData = this.saveData.bind(this);
      this.datatypes = [
        {
          'label': 'Taxonomy',
          'value': 'taxonomies',
        },
        {
          'label': 'Metadata',
          'value': 'metakeys',
        },
      ];
      this.toogleviewtype = [
        {
          'label': 'Toogle Show On',
          'value': 'true',
        },
        {
          'label': 'Toogle Show Off',
          'value': 'false',
        },
      ];
      this.settings = {};
      this.state = {
        'title': null,
        'subtitle': null,
        settings: {
          showNumberOfItems: false,
          setColumn: 2,
          showItem: 5,
        },
      };
    }
    componentWillMount() {
      this.settings = { ...this.state.settings, ...this.props.settings };
      this.setState({
        'settings': { ...this.state.settings, ...this.props.settings },
      });
    }
    componentWillReceiveProps(nextProps) {
      if (nextProps.childUid !== this.props.childUid) {
        this.setState({
          'settings': { ...this.state.settings, ...nextProps.settings },
        });
        this.settings = {};
      }
    }
    handleChangeLoadMore(val) {
      this.settings.LoadMoreOption = val.target.checked;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleTaxonomy(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedTaxonomy = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleMetakey(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedMetakey = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleShowItem(e) {
      this.settings.showItem = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleChangeDataTypes(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedDataType = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelTitle(e) {
      this.settings.title = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelSubTitle(e) {
      this.settings.subtitle = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleChangeToogleViewTypes(val) {
      this.settings.selectedToogleViewType = val.target.checked;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleClassName(e) {
      this.settings.dynamicNameClassCheckBox = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleShowNumberOfItems() {
      if (this.state.settings.showNumberOfItems === 'false' || this.state.settings.showNumberOfItems === false) {
        this.settings.showNumberOfItems = true;
      } else {
        this.settings.showNumberOfItems = false;
      }
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleValueIncrement() {
      let value = null;
      if (this.state.settings.setColumn !== undefined) {
        value = parseInt(this.state.settings.setColumn, 10);
      } else {
        value = 2;
      }
      if ((value + 1) > 4) {
        return;
      }
      value += 1;
      this.settings.setColumn = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleValueDecrement() {
      let value = null;
      if (this.state.settings.setColumn !== undefined) {
        value = parseInt(this.state.settings.setColumn, 10);
      } else {
        value = 2;
      }
      if ((value - 1) < 1) {
        return;
      }
      value -= 1;
      this.settings.setColumn = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    saveData(e) {
      e.preventDefault();
      const allLayout = clone(this.props.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        const findSearchIndex = findIndex(allLayout[find].searchAttr, { uid: this.props.childUid });
        if (findSearchIndex !== -1) {
          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
        }
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);
    }
    render() {
      return (<div>
        <button className="layout-save-button" onClick={this.saveData}><i className="fa fa-floppy-o"></i><span>{API.LANG.SAVE}</span></button>
        <div className="reactive-tab-setting">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#appearance" aria-controls="general" role="tab" data-toggle="tab">{API.LANG.APPEARANCE}</a></li>
            <li role="presentation"><a href="#populate" aria-controls="populate" role="tab" data-toggle="tab">{API.LANG.DATA}</a></li>
          </ul>
          <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="appearance">
              <div className="flex-row">
                <div className="flex-sm-6">
                  <input type="text" className="reactive-input" value= {stringify(this.state.settings.title)} onChange= { this.handelTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_TITLE}/>
                </div>
                <div className="flex-sm-6">
                  <input type="text" className="reactive-input" value= {stringify(this.state.settings.subtitle)} onChange= { this.handelSubTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_SUBTITLE}/>
                </div>
                <div className="flex-sm-6">
                  <input type="text" className="reactive-input" value= {this.state.settings.dynamicNameClassCheckBox} onChange= { this.handleClassName.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME}/>
                </div>
                <div className="flex-sm-6">
                  <div className="grid-choose-option from-search-panel">
                    <div className="flex-row">
                      <div className="flex-sm-6 flex-xs-12">
                        <span className="caption">{API.LANG.SET_COLUMN}</span>
                      </div>
                      <div className="flex-sm-6 flex-xs-12">
                        <div className="choose-grid-button">
                          <p><button onClick={ this.handleValueIncrement}><i className="fa fa-plus"></i></button></p>
                          <p><button onClick={ this.handleValueDecrement}><i className="fa fa-minus"></i></button></p>
                          <p className="gird-value-count">
                            { this.state.settings.setColumn !== undefined ? this.state.settings.setColumn : 2 }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-row">
                <div className="flex-sm-3 flex-xs-12">
                  <span className="caption">{API.LANG.SHOW_NUMBER_OF_ITEMS}</span>
                </div>
                <div className="flex-md-6 flex-xs-12">
                  <ReactToggle
                    defaultChecked={this.state.settings.showNumberOfItems === 'true' || this.state.settings.showNumberOfItems === true}
                    onChange={this.handleShowNumberOfItems.bind(this)}
                  />
                </div>
              </div>
            </div>
            <div role="tabpanel" className="tab-pane" id="populate">
          { /**
            Please select data type
          */}
          <div className="flex-row">
            <div className="flex-sm-6 flex-md-6 flex-xs-12">
              <Select
                name="form-field-name"
                placeholder={API.LANG.PLEASE_ENTER_A_DATA_TYPE}
                value={this.state.settings.selectedDataType}
                options={this.datatypes}
                onChange={this.handleChangeDataTypes}
              />
            </div>
          </div>
          
            { this.state.settings.selectedDataType === 'taxonomies' ? <TaxonomySelection onTaxonomySelection={this.handleTaxonomy} value={this.state.settings.selectedTaxonomy} {...this.props} /> : null }
            { this.state.settings.selectedDataType === 'metakeys' ? <MetadataSelection onMetakeySelection={this.handleMetakey} value={this.state.settings.selectedMetakey} {...this.props} /> : null }
            </div>
          </div>
        </div>
      </div>);
    }
}


LinearCheckBoxPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'childUid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'settings': React.PropTypes.object,
};

export default LinearCheckBoxPanel;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/search/linearcheckboxPanel.js